import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';
import { Suspense, useRef } from 'react';
import "./Image.css";


function Model() {
  const { scene } = useGLTF('/assets/scene.gltf');
  const modelRef = useRef();
  
  // Rotate model slowly on Y-axis
  useFrame(() => {
    if (modelRef.current) {
      modelRef.current.rotation.y += 0.001; // Slow rotation speed
      modelRef.current.rotation.x -= 0.002; // Slight tilt on X-axis
      modelRef.current.rotation.z += 0.003; // Slight tilt on Z-axis
    }
  });
  
  return (
    <primitive 
      ref={modelRef}
      object={scene} 
      scale={0.15}
      position={[0, 0.5, 0]}
    />
  );
}


function LoadingBox() {
  return (
    <mesh>
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color="orange" />
    </mesh>
  );
}


export default function Image() {
  return (
    <div className="image">
      <div className="model-title">
        Site Management
      </div>
      
      <Canvas
        camera={{ 
          position: [-4, 0, 10],
          fov: 45
        }}
        style={{ height: '75vh', width: '100%', background: '#000' }}
      >
        <Suspense fallback={<LoadingBox />}>
          <Model />
        </Suspense>
      </Canvas>
    </div>
  );
}
